<script>
	import analyticsUtilities from 'utilities/analyticsUtilities';
	import Carousel from 'components/carousel.vue';
	import CarouselSlide from 'components/carousel-slide.vue';

	export default {
		components: {
			carousel: Carousel,
			'carousel-slide': CarouselSlide
		},
		props: {
			panels: {
				type: Array,
				required: true,
				default: []
			},
			headerText: {
				type: String
			}
		},
		data() {
			return {
				currentSlide: 0
			};
		},
		computed: {
			images() {
				return this.panels.map(panel => panel.image).filter(image => !!(image && image.url));
			}
		},
		methods: {
			onSignUpButtonClick() {
				analyticsUtilities.fireEvent(analyticsUtilities.events.HOMEPAGE_CLICK, {
					loc: 'HERO_SIGN_UP'
				});
			},
			onSlideChange(slide) {
				this.currentSlide = slide;
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/media';

	.hero-banner {
		padding: 1rem 0 2rem;

		@include media(med) {
			padding: 3rem 0;
		}

		.wrapper {
			display: flex;
			flex-direction: column;
			align-items: center;

			@include media(med) {
				flex-direction: row;
			}
		}

		.hero-content {
			@include media(med) {
				flex: 1 1 60%;
			}
		}

		.hero-title {
			margin-top: 0;
			background-color: $c-blue-accent-1;
			background: linear-gradient(101.26deg, $c-blue-accent-1 -9.74%, $c-blue-dark 80%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;

			&::selection {
				-webkit-text-fill-color: $c-white;
			}
		}

		.sign-up-button {
			background: $c-blue-accent-1 linear-gradient(95.58deg, $c-blue-accent-1 19.29%, $c-blue-dark 91.23%);
			color: $c-white;
			border-color: transparent;

			@include media(med) {
				font-size: 1.125rem;
				padding: 0.625rem 1.5rem;
			}

			&:hover {
				background: $c-blue-accent-3;
				border-color: $c-blue-accent-3;
				color: $c-white;
			}
		}

		.hero-carousel {
			width: 100%;
			max-width: 20rem;
			margin: 3rem 3rem 0;

			@include media(med) {
				margin: 0 3rem;
			}

			.slide-container {
				@include media(sm, max) {
					min-height: calc(100vw - 2rem);
				}
			}
		}

		.hero-slide {
			height: 100%;
		}

		.hero-image {
			height: 100%;
			width: 100%;
			max-height: 20rem;
			object-fit: contain;
		}
	}
</style>
<template>
	<section class="hero-banner">
		<div class="wrapper">
			<div class="hero-content">
				<h2 class="hero-title">{{ headerText }}</h2>
				<a
					href="/teacher-signup"
					class="button sign-up-button"
					@click="onSignUpButtonClick"
					>Sign Up For Your FREE Account</a
				>
			</div>
			<carousel
				v-if="images.length > 0"
				class="hero-carousel"
				:total-slides="images.length"
				autoplay
				ref="carousel"
				@slide-change="onSlideChange">
				<carousel-slide
					v-for="(image, index) in images"
					:key="image.url"
					class="hero-slide"
					animation="fade"
					:position="index"
					:current-slide="currentSlide"
					:total-slides="images.length">
					<img
						class="hero-image"
						:src="image.url"
						:alt="image.alt_text" />
				</carousel-slide>
			</carousel>
		</div>
	</section>
</template>
